import Sider from './Sider';

export default Sider;